import type { FaireProductEntity } from "../../entity_types/product";

export const p_xvfa5hz8qr: FaireProductEntity = {
  token: "p_xvfa5hz8qr",
  type: "product",
  name: "Comfrey Salve for Burns, Bruises, Wounds, Acne, Bug Bites",
  brandToken: "b_2ap734k32w",
  brandName: "Simply Honest Co.",
  imageUrl: "https://cdn.faire.com/fastly/aa0e4c9d5fbefbdeb634b12364b4e9edf13cf6d6baea9c2526b42d29c146ed97.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ebbab73c374125e05e259a7e77c41e298f9b33fc7cae175d7edeed3bbdb08ff.jpeg",
    "https://cdn.faire.com/fastly/022add15ad03b75e08fe495f195ff595413fbc65ab5b3694ca8e0dc6d0fc60fe.jpeg",
    "https://cdn.faire.com/fastly/011175941bb03c3ead0a5046297a5d2b0ba6d67d44fdcee2d07a17868ce92882.jpeg",
    "https://cdn.faire.com/fastly/8703be86e598e7f5362699ad637e507a7987f8dabfad4f8eb337ada2062bf35c.jpeg"
  ],
  priceDollars: 14.7,
  description: "Due to word limitations on Faire, our product descriptions are not complete. You can find more information and complete details on our website at https://SimplyHonestCo.com\n\nOur expertly formulated Comfrey Salve is a versatile remedy for burns, bruises, wounds, acne, and inflammation. The salve is made with comfrey, known for its healing properties, to soothe and promote skin repair. Apply to affected areas for gentle relief and recovery.\n\nItem Details:\n\n * Packaged in a 1 oz or 2 oz amber glass pump bottle\n * Contains organic comfrey leaf, olive oil, shea butter and beeswax \n * No preservatives, No fillers, No chemicals, No additives - just pure, organic plants and oils for the best results! \n",
  tags: [],
  msrpDollars: 29.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:18.929Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
